﻿"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StatePaged = void 0;
const StateUp_1 = require("./StateUp");
class StatePaged extends StateUp_1.StateUp {
    constructor(type, title, inHistory, withNavBars = true) {
        super(title, inHistory);
        this.withNavBars = false;
        this.page = new type();
        this.withNavBars = withNavBars;
    }
    afterStart(args) {
        const _super = Object.create(null, {
            afterStart: { get: () => super.afterStart }
        });
        return __awaiter(this, void 0, void 0, function* () {
            if (this.page)
                this.app.gui.showPage(this.page);
            if (this.withNavBars) {
                this.app.gui.topBar.show();
            }
            else {
                this.app.gui.topBar.hide();
            }
            this.setLabel(this.title);
            yield _super.afterStart.call(this, args);
        });
    }
    setLabel(text) {
        this.app.gui.topBar.ctrls.label.text = text;
    }
}
exports.StatePaged = StatePaged;
//# sourceMappingURL=StatePaged.js.map